module.exports = __webpack_public_path__ + "img/footer9.1caf0963.svg";